{
  "messages": {
    "list_title": "Centro de mensajes",
    "go_to_index": "Regresar a los mensajes",
    "mark_all_read": "Marcar todos como leídos",
    "manage_messages": "Administrar mensajes",
    "manage_help_text": "Seleccione primero los mensajes"
  }
}
